export default "__VITE_ASSET__3650d533__"